
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"10","height":"10","viewBox":"0 0 10 10","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M8.624 5.316A.774.774 0 0 1 8.4 4.77a.74.74 0 0 1 .231-.539A.739.739 0 0 1 9.17 4a.74.74 0 0 1 .539.231.739.739 0 0 1 .231.539.739.739 0 0 1-.231.539.739.739 0 0 1-.539.231.774.774 0 0 1-.546-.224zm-4.2 0A.774.774 0 0 1 4.2 4.77a.74.74 0 0 1 .231-.539A.739.739 0 0 1 4.97 4a.74.74 0 0 1 .539.231.739.739 0 0 1 .231.539.739.739 0 0 1-.231.539.739.739 0 0 1-.539.231.774.774 0 0 1-.546-.224zm-4.2 0A.774.774 0 0 1 0 4.77a.74.74 0 0 1 .231-.539A.739.739 0 0 1 .77 4a.74.74 0 0 1 .539.231.739.739 0 0 1 .231.539.739.739 0 0 1-.231.539.739.739 0 0 1-.539.231.774.774 0 0 1-.546-.224z","fill":"currentColor","fill-rule":"evenodd"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      